<template>
  <div class="quick-link-banner">
    <div class="quicklinks">
      <carousel
        :navigation-enabled="false"
        :pagination-enabled="true"
        :per-page="1"
        :paginationtype="true"
      >
        <slide v-for="(qlinkItem, qlinkIndex) in folderlinks" :key="qlinkIndex">
          <div v-for="(qItem, qIndex) in qlinkItem" :key="qIndex" class="grid-container">
            <div class="item1 grid-item">
              <a :href="qItem.quicklink1">
                <h2>{{ qItem.quicktitle1 }}</h2>
                <span>
                  <img :src="qItem.quickimage1" :alt="qItem.quicktitle1" class="lazyloaded" />
                </span>
                <h2>{{ qItem.quickheading1 }}</h2>
              </a>
            </div>
            <div class="item2 grid-item">
              <a :href="qItem.quicklink2">
                <h2>{{ qItem.quicktitle2 }}</h2>
                <span>
                  <img :src="qItem.quickimage2" :alt="qItem.quicktitle2" class="lazyloaded" />
                </span>
                <h2>{{ qItem.quickheading2 }}</h2>
              </a>
            </div>
            <div class="item3 grid-item">
              <a :href="qItem.quicklink3">
                <h2>{{ qItem.quicktitle3 }}</h2>
                <span>
                  <img :src="qItem.quickimage3" :alt="qItem.quicktitle3" class="lazyloaded" />
                </span>
                <div>
                  <h2>{{ qItem.quickheading3 }}</h2>
                </div>
              </a>
            </div>
            <div class="item4 grid-item">
              <h2>{{ qItem.radiotitle }}</h2>
              <h3
                :style="`${qItem.radiotextcolorcode ? 'color:' + qItem.radiotextcolorcode : '#fff'}`"
              >
                {{ qItem.radioheading }}
              </h3>
            </div>
            <div class="item5 grid-item">
              <a :href="qItem.quicklink4">
                <span>
                  <img :src="qItem.quickimage4" :alt="qItem.quicktitle4" class="lazyloaded" />
                </span>
              </a>
            </div>
            <div class="item6 grid-item">
              <a :href="qItem.quicklink5">
                <h1>{{ qItem.quicktitle5 }}</h1>
                <img :src="qItem.quickimage5" :alt="qItem.quicktitle5" class="lazyloaded" />
                <h2>{{ qItem.quickheading5 }}</h2>
              </a>
            </div>
            <div class="item7 grid-item">
              <a :href="qItem.quicklink6">
                <span>
                  <img :src="qItem.quickimage6" :alt="qItem.quicktitle6" class="lazyloaded" />
                </span>
              </a>
              <div>
                <h2>{{ qItem.quickheading6 }}</h2>
                <span v-if="qItem.quicklink6text">
                  <a :href="qItem.quicklink6" class="item7_cta ripple-animation">
                    {{ qItem.quicklink6text }}
                  </a>
                </span>
              </div>
            </div>
          </div>
        </slide>
      </carousel>
    </div>
  </div>
</template>
<script>
export default {
  name: 'quick-links-folder',
  props: {
    folderlinks: {
      type: Object,
      required: true,
    },
  },
};
</script>
